import React from 'react';

export default function CollocationIcon({ className = '' }) {
  return (
    <div className={`collocationGroup w-12 h-12 ${className}`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 40 41"
        fill="none"
        className="w-full h-full"
      >
        {/* 중앙 블록 */}
        <path
          className="core"
          d="M20.0023 18.7823L28.1119 23.4644V32.8286L20.0023 37.5107L11.8927 32.8286V23.4644L20.0023 18.7823Z"
          fill="#131313"
        />

        {/* 왼쪽 블록 */}
        <path
          className="left"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 7.5981L10.8904 2.91602L2.78076 7.5981V16.9623L10.8904 21.6444L19 16.9623V7.5981Z"
          fill="#1581FC"
        />

        {/* 오른쪽 블록 */}
        <path
          className="right"
          d="M37.2192 7.5981L29.1096 2.91602L21 7.5981V16.9623L29.1096 21.6444L37.2192 16.9623V7.5981Z"
          fill="#1581FC"
        />
      </svg>
    </div>
  );
}
